import { useIntl } from 'react-intl';
import OrganizeStatisticBox from './OrganizeStatisticBox';
import { IOrganizeButtonScrollToFormProps, IOrganizeStatisticBoxProps } from '../models/organize-state.model';
import OrganizeButtonScrollToForm from './OrganizeButtonScrollToForm';

const OrganizeStatistics = (props: Pick<IOrganizeButtonScrollToFormProps, 'scrollToForm'>) => {
	const { scrollToForm } = props;
	const { formatMessage } = useIntl();

	const sourceNavigationI_II = formatMessage(
		{ id: 'bcs-Organize-Statistic-ToolTip-Source' },
		{
			learnMore: (
				<a
					href={
						'https://www.demandgenreport.com/resources/infographics/the-state-of-interactive-content-marketing-statistics-and-trends'
					}
					rel='noreferrer'
					target='_blank'
					className='underline cursor-pointer font-medium text-xs'
					style={{ fontFamily: 'Inter' }}
				>
					{formatMessage({ id: 'bcs-Organize-Statistic-ToolTip-Source-Text-I-II' })}
				</a>
			),
			br: <br />,
		}
	);

	const sourceNavigationIII = formatMessage(
		{ id: 'bcs-Organize-Statistic-ToolTip-Source' },
		{
			learnMore: (
				<a
					href={'https://www.mordorintelligence.com/industry-reports/gamification-market'}
					rel='noreferrer'
					target='_blank'
					className='underline cursor-pointer font-medium text-xs'
					style={{ fontFamily: 'Inter' }}
				>
					{formatMessage({ id: 'bcs-Organize-Statistic-ToolTip-Source-Text-III' })}
				</a>
			),
			br: <br />,
		}
	);

	const coloredText = formatMessage(
		{ id: 'bcs-Organize-Debut-Quiz-Title' },
		{
			firstPart: (
				<span className='text-main-500 font-bold'>
					{formatMessage({ id: 'bcs-Organize-Debut-Quiz-Title-First-Part' })}
				</span>
			),
			secondPart: (
				<span className='font-bold'>{formatMessage({ id: 'bcs-Organize-Debut-Quiz-Title-Second-Part' })}</span>
			),
		}
	);

	const organizeStats: IOrganizeStatisticBoxProps[] = [
		{
			translationKey: 'bcs-Organize-Statistic-Item-I',
			value: '93%',
			source: sourceNavigationI_II,
			svgIcon: 'IconMagnet',
		},
		{
			translationKey: 'bcs-Organize-Statistic-Item-II',
			value: '70%',
			source: sourceNavigationI_II,
			svgIcon: 'IconArrowDollar',
		},
		{
			translationKey: 'bcs-Organize-Statistic-Item-III',
			value: '4.4x',
			source: sourceNavigationIII,
			svgIcon: 'IconGrowth',
		},
	];

	return (
		<div className='justify-between items-center pb-[1.875rem]' id='organize-box'>
			<p
				className='text-dark-800 text-center sm:text-3xl text-xlg font-bold xmd:my-[4.375rem] sm:my-13 my-[1.875rem] px-4 tracking-[-0.06rem]'
				style={{ fontFamily: "'Montserrat', normal" }}
			>
				{formatMessage({ id: 'bcs-Organize-Gamification-Statistics' })}
			</p>

			<div className='flex flex-col justify-center items-center'>
				<div className='flex xmd:space-x-13 md:space-x-5 sm:space-x-3 justify-center sm:flex-row flex-col sm:space-y-0 space-y-13'>
					{organizeStats.map(({ translationKey, value, source, svgIcon }) => {
						return (
							<OrganizeStatisticBox
								key={translationKey}
								source={source}
								svgIcon={svgIcon}
								translationKey={translationKey}
								value={value}
							/>
						);
					})}
				</div>
				<div className='flex flex-col xmd:mt-[6rem] mt-13 sm:mb-13 mb-[1.875rem]'>
					<p
						className='text-headerColor-200 text-center sm:text-3xl text-xlg font-medium sm:mb-[1.875rem] mb-5 px-2'
						style={{ fontFamily: "'Montserrat', normal" }}
					>
						{coloredText}
					</p>
					<p className='text-grayBlue-700 sm:text-xlg text-base text-center px-2'>
						{formatMessage({ id: 'bcs-Organize-Debut-Quiz-Text' })}
					</p>
				</div>
				<OrganizeButtonScrollToForm scrollToForm={scrollToForm} translationKey={'bcs-Organize-Contact-Us'} />
			</div>
		</div>
	);
};

export default OrganizeStatistics;
